//#region Imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base-service.service';
import { ContactInformationDto } from '../model/contactInformationDto';
import { SubmitContactInformationResultDto } from '../model/submitContactInformationResultDto';

//#endregion Imports

@Injectable({
  providedIn: 'root'
})

export class ContactInformationService extends BaseService {

    //#region Constructor
    constructor(http: HttpClient) {
        super(http);
    }
     //#endregion Constructor

    //#region Public Methods
    public Save(contactInformationDto: ContactInformationDto): Observable<GenericMemberResponsePortalResponseDto<SubmitContactInformationResultDto>> {
        return this.Post('/Response/ContactInformation', contactInformationDto);
    }
    //#endregion Public Methods
}
